import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import Box from "@mui/material/Box";
import { TableContainer, Paper } from "@mui/material";
import { Get_limited_Choose_Fields_From_MongoDB_With_Search } from "../../../api/Get_limited_Choose_Fields_From_MongoDB_With_Search";
import { Delete_One_From_MongoDB } from "../../../api/Delete_One_From_MongoDB";
import { StaffuseAuth } from "../../../security/StaffuseAuth";

function ViewEvents2024({ id }) {
  const { logout } = StaffuseAuth();

  const [Arr_Events, setArr_Events] = useState([]);

  useEffect(() => {
    if (id !== "AddSchool") {
      Get_limited_Choose_Fields_From_MongoDB_With_Search(
        "Schools",
        "Events",
        { School_id: id },
        100,
        setArr_Events,
        {},
        logout
      );
    }
  }, [id]);

  let Arr_PropsToSee = ["Date", "Type_of_Event", "Lead_Contact_Name", "Notes"];

  return (
    <div>
      <h2>View 2024 Events</h2>
      {Arr_Events && Array.isArray(Arr_Events) && Arr_Events.length > 0 ? (
        <>
          <Grid container spacing={2}>
            <Box
              component="main"
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                maxWidth: "95%",
                maxHeight: "400px",
                flexGrow: 1,
                p: 1,
                marginLeft: "10px",
              }}
            >
              <TableContainer
                component={Paper}
                sx={{
                  width: "100%",
                  margin: "0 auto",
                  overflow: "auto",
                }}
              >
                <Table
                  aria-label="simple table"
                  sx={{
                    border: "1px solid #e0e0e0",
                    tableLayout: "fixed",
                  }}
                >
                  <TableHead>
                    <TableRow>
                      {Arr_PropsToSee &&
                      Array.isArray(Arr_PropsToSee) &&
                      Arr_PropsToSee.length > 0 ? (
                        Arr_PropsToSee.map((Obj_PropToSee) => {
                          return (
                            <TableCell
                              className="tableCellHeader" // Add this line to include the CSS class
                              align="left"
                              style={{
                                position: "sticky",
                                Top: 0,
                                zIndex: 1,
                                fontWeight: "bold", // Make Text bold
                                padding: "8px", // Adjust padding as needed To make cells smaller
                              }}
                            >
                              {Obj_PropToSee}
                            </TableCell>
                          );
                        })
                      ) : (
                        <></>
                      )}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {Arr_Events.map((Obj_Event, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:hover": {
                            backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                            "& .MuiTableCell-root": {
                              padding: "8px",
                              wordWrap: "break-word",
                              overflowWrap: "break-word", // Adjust padding here to make cells smaller
                            },
                          },
                        }}
                      >
                        {Arr_PropsToSee &&
                        Array.isArray(Arr_PropsToSee) &&
                        Arr_PropsToSee.length > 0 ? (
                          Arr_PropsToSee.map((Obj_PropToSee) => {
                            return (
                              <TableCell
                                className="tableCellHeader" // Add this line to include the CSS class
                                align="left"
                                style={{
                                  position: "sticky",
                                  Top: 0,
                                  zIndex: 1,
                                  padding: "8px", // Adjust padding as needed To make cells smaller
                                }}
                              >
                                {Obj_Event[Obj_PropToSee]
                                  ? Obj_Event[Obj_PropToSee]
                                  : ""}
                              </TableCell>
                            );
                          })
                        ) : (
                          <></>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Grid>
        </>
      ) : (
        <h3>No 2024 Events</h3>
      )}
    </div>
  );
}

export default ViewEvents2024;
